"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.offerStreamsToCreate = offerStreamsToCreate;
exports.offerStreamsToApiCalls = offerStreamsToApiCalls;
const logger = __importStar(require("../logger.js"));
/**
 * Resolve the granted permissions into streams to create, ancestors first.
 *
 * Insertion order is parent-before-child, so the batch applies top-down with no
 * separate sort.
 */
function offerStreamsToCreate(permissions, modelStreams) {
    const wanted = new Map();
    const add = (id, { granted = false } = {}) => {
        if (wanted.has(id))
            return;
        const data = modelStreams.getDataById(id, false);
        if (data == null) {
            // Unknown to the model. What reaches here is the requester's OWN root
            // (e.g. `bridge-mira`), since `:_cmc:*` and `:_system:*` are filtered below.
            //
            // Only ever create an id the user explicitly granted, never an inferred
            // ancestor: inventing a hierarchy inside someone else's subtree is the
            // requester's business, not ours. Hence `granted` is not defaulted true.
            if (!granted)
                return;
            wanted.set(id, { id, name: id });
            return;
        }
        wanted.set(id, { id, name: data.name ?? id, parentId: data.parentId ?? undefined });
    };
    for (const perm of permissions) {
        const streamId = perm?.streamId;
        if (typeof streamId !== 'string' || streamId.startsWith(':'))
            continue;
        // `getParentsIds` recurses with `throwErrorIfNotFound` hardcoded true further
        // down, so a single stream the model does not know can abort the whole walk.
        // Isolate each one: a bad entry must not cost the others their ancestors.
        try {
            for (const ancestorId of modelStreams.getParentsIds(streamId, false))
                add(ancestorId);
        }
        catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            logger.warn(`offerStreams: could not resolve ancestors of "${streamId}":`, message);
        }
        add(streamId, { granted: true });
    }
    return [...wanted.values()];
}
/** Turn the resolved list into `streams.create` API calls. */
function offerStreamsToApiCalls(streams) {
    return streams.map((s) => ({
        method: 'streams.create',
        params: s.parentId != null ? { id: s.id, name: s.name, parentId: s.parentId } : { id: s.id, name: s.name },
    }));
}
